/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTop = function scrollTop(target, val) {
    if (val !== undefined) {
        return target.scrollTo(0, val);
    }
    if ("scrollTop" in target) {
        return target.scrollTop;
    }
    // @ts-ignore
    if (!!target.pageYOffset) {
        // @ts-ignore
        return target.pageYOffset;
    }
    // @ts-ignore
    return target.document.documentElement.pageYOffset;
};